import React from 'react';
import { pureRender } from 'epic-alt-utils';
import autobind from 'core-decorators/lib/autobind';
import { NavActions } from '../../actions';
import './propertyLogo.sass';

@pureRender
export default class PropertyLogo extends React.Component {

    @autobind
    logoClick(e) {
        if (this.props.logoLink && this.props.logoLink.onClick && typeof this.props.logoLink.onClick === 'function') {
            this.props.logoLink.onClick(e);
        }

        NavActions.closeMobileTablet.defer();
    }

    render() {
        const href = this.props.logoLink ? this.props.logoLink.href : '#';

        return (
            <a
                id="propLogo"
                href={href}
                className={`propLogo ${this.context.isTablet ? 'tablet' : ''} ${this.props.searchActive ? 'search-active' : ''}`}
                onClick={this.logoClick}></a>
        );
    }
}

PropertyLogo.propTypes = {
    logoLink: React.PropTypes.object,
    searchActive: React.PropTypes.bool
};

PropertyLogo.contextTypes = {
    isTablet: React.PropTypes.bool
};



/** WEBPACK FOOTER **
 ** ./app/scripts/components/propertyLogo/PropertyLogo.js
 **/